__webpack_require__.p = "https://xiscob.github.io/l2-dps-calculator/";